import React from 'react';

import { DogPileTierCounts } from '@/sections/customerManagement/types/dogPile.types';

interface DogPileSummaryHeaderProps {
  tierCounts: DogPileTierCounts;
  categoryLabel: string;
}

interface TierDisplayItem {
  label: string;
  count: number;
  colorClassName: string;
}

export const DogPileSummaryHeader: React.FC<DogPileSummaryHeaderProps> = ({
  tierCounts,
  categoryLabel,
}) => {
  const tierItems: TierDisplayItem[] = [
    {
      label: 'Immediate Attention',
      count: tierCounts.critical,
      colorClassName: 'text-chariot-stroke-critical',
    },
    {
      label: 'Needs Attention',
      count: tierCounts.high,
      colorClassName: 'text-chariot-stroke-high',
    },
    {
      label: 'Monitor Closely',
      count: tierCounts.moderate,
      colorClassName: 'text-chariot-stroke-medium',
    },
    {
      label: 'Delivering Value',
      count: tierCounts.healthy,
      colorClassName: 'text-chariot-stroke-light-green',
    },
  ];

  const activeTiers = tierItems.filter(item => item.count > 0);

  return (
    <div className="border-chariot-stroke bg-chariot-background-secondary mb-4 flex flex-wrap items-center gap-2 rounded-lg border px-4 py-2.5">
      <span className="text-chariot-text-primary text-sm font-semibold">
        {categoryLabel} ({tierCounts.total})
      </span>

      {activeTiers.length > 0 && (
        <>
          <span className="text-chariot-text-secondary text-sm">—</span>
          {activeTiers.map((item, index) => (
            <React.Fragment key={item.label}>
              <span className={`text-sm font-medium ${item.colorClassName}`}>
                {item.count} {item.label}
              </span>
              {index < activeTiers.length - 1 && (
                <span className="text-chariot-text-secondary text-sm">·</span>
              )}
            </React.Fragment>
          ))}
        </>
      )}

      {activeTiers.length === 0 && tierCounts.total === 0 && (
        <span className="text-chariot-text-secondary text-sm">
          No customers
        </span>
      )}
    </div>
  );
};
